// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__P4vFr","info":"UpdateTermsInfo_info__207vx"};